const STORAGE_KEY = 'ld_web_update_banner_dismissed'

/**
 * REACT_APP_WEB_UPDATE_BANNER controls the bottom-right refresh popup.
 * - empty / false / 0 / off → hidden
 * - true → show once until dismissed (bump to a new value to show again)
 * - any release key (e.g. 2026-07-31) → preferred; change the key on each ship
 */
export function getWebUpdateBannerKey(): string | null {
    const raw = process.env.REACT_APP_WEB_UPDATE_BANNER?.trim()
    if (!raw) return null

    const normalized = raw.toLowerCase()
    if (normalized === 'false' || normalized === '0' || normalized === 'no' || normalized === 'off') {
        return null
    }

    return raw
}

export function isWebUpdateBannerDismissed(bannerKey: string): boolean {
    try {
        return localStorage.getItem(STORAGE_KEY) === bannerKey
    } catch {
        return false
    }
}

export function dismissWebUpdateBanner(bannerKey: string): void {
    try {
        localStorage.setItem(STORAGE_KEY, bannerKey)
    } catch {
        // Ignore quota / private-mode failures; in-memory hide still applies.
    }
}

export function shouldShowWebUpdateBanner(): boolean {
    const bannerKey = getWebUpdateBannerKey()
    if (!bannerKey) return false
    return !isWebUpdateBannerDismissed(bannerKey)
}
